import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { API_BASE_URL } from '@/services/api';

const AUTH_KEY = 'helios_auth_user';

/**
 * Telegram SSO deeplink landing.
 * Exchanges a one-time token (from helios-aggregate-bot) for a user object,
 * writes it to localStorage (same key useAuth reads), then redirects home.
 */
export default function DeeplinkPage() {
  const { token } = useParams<{ token: string }>();
  const navigate = useNavigate();
  const [status, setStatus] = useState<'loading' | 'ok' | 'error'>('loading');
  const [errMsg, setErrMsg] = useState<string>('');

  useEffect(() => {
    let cancelled = false;
    (async () => {
      if (!token) {
        setStatus('error');
        setErrMsg('Відсутній токен.');
        return;
      }
      try {
        const res = await fetch(`${API_BASE_URL}/auth/telegram-sso/${token}`);
        const data = await res.json();
        if (cancelled) return;
        if (res.ok && data.ok && data.user) {
          localStorage.setItem(AUTH_KEY, JSON.stringify(data.user));
          if (data.token) localStorage.setItem('helios_auth_token', data.token);
          setStatus('ok');
          setTimeout(() => navigate('/', { replace: true }), 600);
        } else {
          setStatus('error');
          const map: Record<string, string> = {
            token_not_found: 'Посилання недійсне.',
            token_already_used: 'Посилання вже використано. Згенеруйте нове у боті.',
            token_expired: 'Термін дії посилання минув (5 хв). Згенеруйте нове у боті.',
            user_mapping_missing: 'Користувача не знайдено.',
          };
          setErrMsg(map[data.error] ?? 'Помилка авторизації.');
        }
      } catch {
        if (cancelled) return;
        setStatus('error');
        setErrMsg('Не вдалося зв’язатися з сервером.');
      }
    })();
    return () => { cancelled = true; };
  }, [token, navigate]);

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center',
      justifyContent: 'center', background: '#0F0F0F', color: '#E5E5E5',
      fontFamily: 'system-ui, sans-serif',
    }}>
      <div style={{ textAlign: 'center', maxWidth: 380, padding: 24 }}>
        {status === 'loading' && (
          <>
            <i className="ri-loader-4-line" style={{ fontSize: 32, color: 'var(--accent)' }} />
            <p style={{ marginTop: 16, color: '#A0A0A8' }}>Вхід через Telegram…</p>
          </>
        )}
        {status === 'ok' && (
          <>
            <i className="ri-checkbox-circle-line" style={{ fontSize: 36, color: '#22C55E' }} />
            <p style={{ marginTop: 16 }}>Вхід виконано. Перенаправлення…</p>
          </>
        )}
        {status === 'error' && (
          <>
            <i className="ri-error-warning-line" style={{ fontSize: 36, color: 'var(--accent)' }} />
            <p style={{ marginTop: 16 }}>{errMsg}</p>
            <button
              onClick={() => navigate('/login', { replace: true })}
              style={{
                marginTop: 20, padding: '8px 20px', background: 'color-mix(in srgb, var(--text) 10%, transparent)', color: 'var(--text)', border: 'none', borderRadius: 8, cursor: 'pointer',
              }}
            >
              До входу
            </button>
          </>
        )}
      </div>
    </div>
  );
}
